"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CellEvolutionNewWorld__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "admAdd",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_cellno",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_adaption",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_surviveability",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_division",
                type: "uint256",
            },
        ],
        name: "checkdeath",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_id",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_cellno",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_adaption",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_surviveability",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_division",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_environment",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_day",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_totalscore",
                type: "uint256",
            },
            {
                internalType: "string",
                name: "_finaltitle",
                type: "string",
            },
        ],
        name: "dnamerge",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_cellDBId",
                type: "uint256",
            },
        ],
        name: "getCellDB",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "id",
                        type: "uint256",
                    },
                    {
                        internalType: "address",
                        name: "creator",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "cellno",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "adaption",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "surviveability",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "division",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "environment",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "day",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "totalscore",
                        type: "uint256",
                    },
                    {
                        internalType: "string",
                        name: "finaltitle",
                        type: "string",
                    },
                    {
                        internalType: "uint256",
                        name: "belong",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "version",
                        type: "uint256",
                    },
                ],
                internalType: "struct ICellEvolutionNewWorld.CellEvolution",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_cellHistoryId",
                type: "uint256",
            },
        ],
        name: "getCellHistory",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "id",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "cellno",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "adaption",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "surviveability",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "division",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "environment",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "day",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "totalscore",
                        type: "uint256",
                    },
                    {
                        internalType: "string",
                        name: "worldtitle",
                        type: "string",
                    },
                    {
                        internalType: "uint256",
                        name: "startcellid",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "endcellid",
                        type: "uint256",
                    },
                    {
                        internalType: "string",
                        name: "cellsdetail",
                        type: "string",
                    },
                    {
                        internalType: "uint256",
                        name: "version",
                        type: "uint256",
                    },
                ],
                internalType: "struct ICellEvolutionNewWorld.CellHistory",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "historyno",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "inheritance",
        outputs: [
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "inheritanceno",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isOpen",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "newinheritance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_cellno",
                type: "uint256",
            },
        ],
        name: "setCellno",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_worldId",
                type: "uint256",
            },
            {
                internalType: "string",
                name: "_newtitle",
                type: "string",
            },
        ],
        name: "setHomeworld",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bool",
                name: "_isopen",
                type: "bool",
            },
        ],
        name: "setIsOpen",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_versionno",
                type: "uint256",
            },
        ],
        name: "setVersion",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_historyno",
                type: "uint256",
            },
        ],
        name: "sethistoryno",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "totalcell",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "version",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "worldtitlecheck",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "id",
                        type: "uint256",
                    },
                    {
                        internalType: "address",
                        name: "creator",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "cellno",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "adaption",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "surviveability",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "division",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "environment",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "day",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "totalscore",
                        type: "uint256",
                    },
                    {
                        internalType: "string",
                        name: "finaltitle",
                        type: "string",
                    },
                    {
                        internalType: "uint256",
                        name: "belong",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "version",
                        type: "uint256",
                    },
                ],
                internalType: "struct ICellEvolutionNewWorld.CellEvolution",
                name: "_cellDB",
                type: "tuple",
            },
        ],
        name: "writecell",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "id",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "cellno",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "adaption",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "surviveability",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "division",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "environment",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "day",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "totalscore",
                        type: "uint256",
                    },
                    {
                        internalType: "string",
                        name: "worldtitle",
                        type: "string",
                    },
                    {
                        internalType: "uint256",
                        name: "startcellid",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "endcellid",
                        type: "uint256",
                    },
                    {
                        internalType: "string",
                        name: "cellsdetail",
                        type: "string",
                    },
                    {
                        internalType: "uint256",
                        name: "version",
                        type: "uint256",
                    },
                ],
                internalType: "struct ICellEvolutionNewWorld.CellHistory",
                name: "_worldDB",
                type: "tuple",
            },
        ],
        name: "writeworld",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
class CellEvolutionNewWorld__factory extends ethers_1.ContractFactory {
    constructor(signer) {
        super(_abi, _bytecode, signer);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.CellEvolutionNewWorld__factory = CellEvolutionNewWorld__factory;
CellEvolutionNewWorld__factory.bytecode = _bytecode;
CellEvolutionNewWorld__factory.abi = _abi;
//# sourceMappingURL=CellEvolutionNewWorld__factory.js.map